module.exports = __webpack_public_path__ + "img/huangfuyao.4ef1a6ea.jpg";